<template>
  <section style="text-align:right;">
    <b-button
      @click="addLesson"
      type="is-warning"
      icon-left="plus"
      v-if="getProfile && getProfile.isAdmin"
    >
      Add {{ level }} lesson
    </b-button>
    <b-table
      :data="combinedLessons"
      ref="table"
      class="table"
      :opened-detailed="defaultOpenedDetails"
      detailed
      detail-key="id"
      :show-detail-icon="false"
      paginated
      style="text-align:left;"
    >
      <b-table-column field="title" label="Title" width="30" v-slot="props">
        {{ props.row.title }}
      </b-table-column>

      <b-table-column
        field="description"
        label="Description"
        width="30"
        v-slot="props"
      >
        {{ props.row.description }}
      </b-table-column>

      <b-table-column
        field="startAt.seconds"
        label="Start Time"
        width="20"
        v-slot="props"
      >
        {{ (props.row.startAt.seconds * 1000) | asDateTime }}
      </b-table-column>

      <b-table-column
        field="duration"
        label="Duration"
        v-slot="props"
        width="5"
      >
        {{ props.row.duration }} mins
      </b-table-column>

      <b-table-column
        width="5"
        label="Admin Tools"
        v-slot="props"
        v-if="getProfile && getProfile.isAdmin"
      >
        <b-button
          type="is-info"
          icon-right="pen"
          title="Edit"
          @click="editLessonDetails(props.row)"
        />
        <b-button
          type="is-danger"
          icon-right="trash"
          title="Delete"
          style="margin-left: 5px;"
          @click="deleteLesson(props.row)"
        />
      </b-table-column>

      <template #detail="">
        <div>
          <b-tag
            type="is-warning"
            style="margin-bottom: 10px;"
            v-show="lessonForEdit.id === 'new-lesson'"
          >
            NEW Lesson
          </b-tag>
          <b-field label="Title" label-position="inside">
            <b-input v-model="lessonForEdit.title"></b-input>
          </b-field>
          <b-field label="Description" label-position="inside">
            <b-input
              type="textarea"
              v-model="lessonForEdit.description"
            ></b-input>
          </b-field>
          <b-field label="Start date and time" label-position="inside">
            <b-datetimepicker
              placeholder="Click to select..."
              icon="calendar-today"
              locale="en-AU"
              position="is-top-right"
              v-model="startTimeOfCurrentLesson"
              horizontal-time-picker
            ></b-datetimepicker>
          </b-field>

          <b-field label="Duration (in minutes)" label-position="inside">
            <b-input v-model.number="lessonForEdit.duration"></b-input>
          </b-field>

          <b-button icon-left="check" type="is-success" @click="saveLesson">
            {{ lessonForEdit.id === "new-lesson" ? "Add" : "Save" }}
          </b-button>
          <b-button
            icon-left="times"
            style="margin-left: 10px;"
            @click="
              defaultOpenedDetails = [];
              lessonForEdit = {};
              newLesson = null;
            "
          >
            Cancel
          </b-button>
        </div>
      </template>
    </b-table>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import { firestore } from "@/services/firebase";
import { cloneObj } from "vue-chess-shared/utils";

export default {
  name: "LiveLessonsTable",
  props: {
    lessons: {},
    level: {},
  },
  computed: {
    ...mapGetters(["getProfile"]),
    combinedLessons() {
      if (!this.newLesson) return this.lessons;
      return [...this.lessons, ...[this.newLesson]];
    },
    startTimeOfCurrentLesson: {
      get() {
        return this.lessonForEdit.startAt.toDate();
      },
      set(v) {
        this.lessonForEdit.startAt.seconds = Math.round(v / 1000);
      },
    },
  },
  data() {
    return {
      lessonForEdit: {}, // this will be a clone object of a lesson when edit is clicked
      editItemId: null,
      defaultOpenedDetails: [],
      newLesson: null,
    };
  },
  methods: {
    editLessonDetails(lesson) {
      this.defaultOpenedDetails = [lesson.id];
      const clonedLesson = cloneObj(lesson);
      clonedLesson.id = lesson.id; // for some reason id is not being cloned by the cloneObj function

      this.$set(this, "lessonForEdit", clonedLesson);
    },
    saveLesson() {
      const lessonId = this.lessonForEdit.id;
      delete this.lessonForEdit.id;

      if (lessonId === "new-lesson") {
        // add new lesson
        firestore
          .collection("live_lessons")
          .doc(this.level)
          .collection("lessons")
          .add(this.lessonForEdit);
      } else {
        // update current lesson
        firestore
          .collection("live_lessons")
          .doc(this.level)
          .collection("lessons")
          .doc(lessonId)
          .update(this.lessonForEdit);
      }

      this.newLesson = null;
      this.lessonForEdit = {};
      this.defaultOpenedDetails = [];
    },
    deleteLesson(lesson) {
      this.$buefy.dialog.confirm({
        title: `${lesson.title}`,
        message: "Are you sure you want to delete this lesson?",
        confirmText: "Delete",
        type: "is-danger",
        onConfirm: () => {
          firestore
            .collection("live_lessons")
            .doc(this.level)
            .collection("lessons")
            .doc(lesson.id)
            .delete();
        },
      });
    },
    addLesson() {
      const newLessonTempId = "new-lesson";
      const newLesson = {
        id: newLessonTempId,
        description: "-",
        title: "New Lesson Title",
        duration: 5,
        startAt: { seconds: Date.now() / 1000, nanoseconds: 0 },
      };
      this.$set(this, "lessonForEdit", newLesson);
      this.newLesson = newLesson;
      this.defaultOpenedDetails = [newLessonTempId];
    },
  },
};
</script>
<style scoped>
td {
  border: 1px solid lightgray;
  padding: 10px;
}

.table >>> tr.detail {
  background-color: #e6e6e6 !important;
}
</style>
